import React, { useRef, useState, useEffect } from 'react'

import { DiscountBar } from './DiscountBar/DiscountBar'
import { useGetPromoBannerDispatchedActions, useGetPromoBannerData } from './promoBannerHooks'

export const PromoBanner = () => {
  const stickyBarRef = useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = useState(false)
  const { dispatchApplyPromoCodeAndShowModal, dispatchRedirect, dispatchTrackUTMAndPromoCode } =
    useGetPromoBannerDispatchedActions()
  const { canApplyPromo, promoText } = useGetPromoBannerData()

  const onScroll = () => {
    const bannerContainer = stickyBarRef.current
    setIsSticky(bannerContainer ? window.pageYOffset > bannerContainer.offsetTop : false)
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  const applyDiscount = () => {
    dispatchApplyPromoCodeAndShowModal()
    dispatchRedirect()
    dispatchTrackUTMAndPromoCode()
  }

  return (
    <div ref={stickyBarRef}>
      <DiscountBar
        applyDiscount={applyDiscount}
        isHidden={!canApplyPromo}
        isSticky={isSticky}
        promoText={promoText}
      />
    </div>
  )
}
